export const languages = [
  { code: 'en', name: 'English' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'th', name: 'ไทย' },
  { code: 'es', name: 'Español' },
  { code: 'ru', name: 'Русский' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'kk', name: 'Қазақша' },
  { code: 'id', name: 'Bahasa Indonesia' },
  { code: 'de', name: 'Deutsch' },
] as const;
  
  export const defaultLanguage = 'en';
  
  export type Language = (typeof languages)[number]['code'];
  
  // 每种语言的游戏数据文件路径
  export const gameDataPaths: Record<Language, string> = {
    en: 'games-en.json',
    ja: 'games-ja.json',
    ko: 'games-ko.json',
    th: 'games-th.json',
    es: 'games-es.json',
    ru: 'games-ru.json',
    vi: 'games-vi.json',
    kk: 'games-kk.json',
    id: 'games-id.json',
    de: 'games-de.json',
  };